var _path, _path2, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSmokingIconTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 3.99992L5.99325 8.66658H1.33325V10.6666H7.99325L12.6599 15.3333L13.4999 14.4999L2.16659 3.16659L1.33325 3.99992ZM13.6666 8.66659H14.6666V10.6666H13.6666V8.66659ZM11.9999 8.66659H12.9999V10.6666H11.9999V8.66659ZM12.5666 3.25325C12.9799 2.84659 13.2333 2.28659 13.2333 1.66659H12.2333C12.2333 2.34659 11.6799 2.89992 10.9999 2.89992V3.89992C12.4933 3.89992 13.6666 5.11992 13.6666 6.61325V7.99992H14.6666V6.61325C14.6666 5.12659 13.8133 3.84659 12.5666 3.25325ZM9.66658 5.79992H10.6866C11.3866 5.79992 11.9999 6.29325 11.9999 7.16658V7.99992H12.9999V6.93992C12.9999 5.73992 11.9333 4.83325 10.6866 4.83325H9.66658C8.98658 4.83325 8.43325 4.17992 8.43325 3.49992C8.43325 2.81992 8.98658 2.33325 9.66658 2.33325V1.33325C8.43325 1.33325 7.43325 2.33325 7.43325 3.56659C7.43325 4.79992 8.43325 5.79992 9.66658 5.79992ZM11.3333 10.6199V8.66659H9.37992L11.3333 10.6199Z",
    fill: "#2800A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_326_530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 3.99992L5.99325 8.66658H1.33325V10.6666H7.99325L12.6599 15.3333L13.4999 14.4999L2.16659 3.16659L1.33325 3.99992ZM13.6666 8.66659H14.6666V10.6666H13.6666V8.66659ZM11.9999 8.66659H12.9999V10.6666H11.9999V8.66659ZM12.5666 3.25325C12.9799 2.84659 13.2333 2.28659 13.2333 1.66659H12.2333C12.2333 2.34659 11.6799 2.89992 10.9999 2.89992V3.89992C12.4933 3.89992 13.6666 5.11992 13.6666 6.61325V7.99992H14.6666V6.61325C14.6666 5.12659 13.8133 3.84659 12.5666 3.25325ZM9.66658 5.79992H10.6866C11.3866 5.79992 11.9999 6.29325 11.9999 7.16658V7.99992H12.9999V6.93992C12.9999 5.73992 11.9333 4.83325 10.6866 4.83325H9.66658C8.98658 4.83325 8.43325 4.17992 8.43325 3.49992C8.43325 2.81992 8.98658 2.33325 9.66658 2.33325V1.33325C8.43325 1.33325 7.43325 2.33325 7.43325 3.56659C7.43325 4.79992 8.43325 5.79992 9.66658 5.79992ZM11.3333 10.6199V8.66659H9.37992L11.3333 10.6199Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_326_530)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.66675,
    y: -8.66675,
    width: 33.3333,
    height: 33.3333,
    fill: "#2800A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_326_530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -9,
    width: 34,
    height: 34
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -8.66675,
    y: -8.66675,
    width: 33.3333,
    height: 33.3333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_326_530)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmokingIconTransavia);
export default __webpack_public_path__ + "static/media/no-smoking-icon-transavia.221ddc0b32cdbea2b780a1bd4ad47559.svg";
export { ForwardRef as ReactComponent };